import type { IBlogList } from '../../../models/blog-list.model';
import BlogListItemApiModel from './blog-list-item.api-model';

export default class BlogListApiModel {
  public items!: BlogListItemApiModel[];
  public numberOfPages!: number;

  public static mapToBusinessModel(apiModel: BlogListApiModel): IBlogList {
    return {
      items: apiModel.items.map(BlogListItemApiModel.mapToBusinessModel),
      numberOfPages: apiModel.numberOfPages,
    };
  }
}

